import store from "@/store/index.store"

export const MIXINS = {
  methods: {
    /**
     *
     * @param {string} eventLabel
     * @param {{}} context
     *
     * track individual analytics event and send it to multiple sources
     */
    trackAnalyticsEvent: (eventLabel, context = {}) => {
      if (typeof window !== "undefined" && window.rudderanalytics) {
        const user = store.getters["User/getUser"]
        const properties = { ...context, isAnonymous: !user?.id }

        window.rudderanalytics.track(eventLabel, properties)
      }
    },
    /**
     *
     * @param {string} userId
     * @param {{}} userDetails
     *
     * track the identity of a user on multiple analytics sources
     */
    trackAnalyticsIdentity: (userId, userDetails = {}) => {
      if (typeof window !== "undefined" && window.rudderanalytics && userId) {
        window.rudderanalytics.identify(userId, { ...userDetails })
      }
    },
    /**
     * track page view on multiple analytics sources
     */

    trackAnalyticsPageView: (pageName = "", pageProperties = {}) => {
      if (typeof window !== "undefined" && window.rudderanalytics) {
        const user = store.getters["User/getUser"]
        const isAnonymous = !user?.id
        window.rudderanalytics.page(pageName, {
          ...pageProperties,
          isAnonymous,
        })
      }
    },

    trackAnalyticsGroup: (groupId, groupProperties = {}) => {
      if (typeof window !== "undefined" && window.rudderanalytics) {
        window.rudderanalytics.group(groupId, { ...groupProperties })
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/utils/mixins.js